import { useEffect } from 'react';

/**
 * Hook to prevent background scroll when a modal/overlay is open
 * @param {boolean} isOpen - Whether the modal is open
 */
export default function useBodyScrollLock(isOpen) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
}
